<template>
  <form class="form form--contact" ref="contactForm" @submit.prevent="handleContactForm">
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form__field">
          <input name="user_name" class="form__input" type="text" required/>
          <label class="form__label" for="user_name">Name</label>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form__field">
          <input name="user_email" class="form__input" type="email" required/>
          <label class="form__label" for="user_email">Email</label>
        </div>
      </div>
      <div class="col-xs-12 col-md-12">
        <div class="form__field form__field--antispam">
          <input name="url" class="form__input" type="text" ref="antispam" />
          <label class="form__label">Leave this empty</label>
        </div>
      </div>
      <div class="col-xs-12 col-md-12">
        <div class="form__field">
          <textarea name="user_message" class="form__input" required></textarea>
          <label class="form__label" for="user_message">Message</label>
        </div>

        <div class="text--center">
          <button type="submit" name="button" class="btn"><span class="btn__inner">Send message</span></button>
        </div>
      </div>
    </div>

    <div class="form__feedback">
      <div class="form__feedback__success">
        <IconSuccess class="mb-2"></IconSuccess>
        <p>Thank you, your message has been sent.</p>
      </div>
      <div class="form__feedback__error">
        <IconError class="mb-4"></IconError>
        <p>Sorry there was an error, please try again.</p>
        <p>Or use the details above.</p>
      </div>
    </div>

  </form>
</template>

<script>
// Icons
import IconSuccess from '../icons/IconSuccess'
import IconError from '../icons/IconError'

// Email JS
import emailjs from 'emailjs-com'

export default {
  name: 'ContactForm',
  components: {
    IconSuccess,
    IconError
  },
  methods: {
    handleContactForm: function (e) {
      if (this.$refs.antispam.value === '') {
        emailjs.sendForm('service_4wlqios', 'template_9hsmtf9', e.target, 'user_uNz3QX1BfpjcPFh3h6nJo')
          .then((result) => {
            this.$refs.contactForm.classList.add('is--successful')
          }, (error) => {
            if (error) {
              this.$refs.contactForm.classList.add('is--unsuccessful')
              setTimeout(function () {
                this.$refs.contactForm.reset()
                this.$refs.contactForm.classList.remove('is--unsuccessful')
              }, 3000)
            }
          })
      }
    }
  }
}
</script>
